 <div class="loader_bg h-100 d-flex justify-content-center align-items-center">
   <p>   {{loadingMessage}}  </p>
  <div class="loader">
  </div>
</div>
